import { useDebugValue, useEffect, useState } from 'react';
import { interceptErrorMessage } from '../../../shared/helpers/apiErrorsInterceptor';

import ajaxClient from '../../../utils/ajaxClient';

const useGetOrganizations = () => {
  useDebugValue('useGetOrganizations');

  const [isFetching, setIsFetching] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const fetchRegisterOrganizations = () => {
    const url = 'Organizations/Organizations/Organizations';

    return ajaxClient
      .getRequest(url, null)
      .then((response) => {
        if (response) {
          setOrganizations(response.data);
          setIsFetching(false);
          setErrorMessage(null);
        }
      })
      .catch((exception) => {
        setErrorMessage(interceptErrorMessage(exception));
        setIsFetching(false);
      });
  };

  useEffect(() => {
    fetchRegisterOrganizations();
  }, []);

  return { isFetching, organizations, errorMessage };
};

export default useGetOrganizations;
